import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { TERMS_VERSION, TERMS_URL, DPA_URL } from '../data/terms';

// A real club admin of a non-house club, on the get-started trial, who hasn't
// agreed to the current terms. Not a super admin acting in the club (the server
// refuses them too), and not when we can't tell the club isn't the house club
// or that the get-started trial is on.
export const shouldShowTerms = (user) =>
  !!user
  && user.role === 'CLUB_ADMIN'
  && !user.actingAs
  && user.features?.getStarted === true
  && user.club?.isHouseClub === false
  && user.club?.termsVersion !== TERMS_VERSION;

const overlay = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 2000,
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem',
};
const box = {
  background: '#fff', color: '#222', borderRadius: 12, padding: '1.5rem', maxWidth: 440, width: '100%',
  boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
};

export default function TermsPrompt() {
  const { user, updateUser } = useAuth();
  const [agree, setAgree] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  if (!shouldShowTerms(user)) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!agree) { setError('Please tick the box to agree.'); return; }
    setBusy(true);
    setError('');
    try {
      const { data } = await axios.post('/api/clubs/terms/accept', { agree: true });
      updateUser({ ...user, club: { ...user.club, termsVersion: data.termsVersion, termsAcceptedAt: data.termsAcceptedAt } });
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
      setBusy(false);
    }
  };

  return (
    <div style={overlay} role="dialog" aria-modal="true" aria-labelledby="terms-prompt-title">
      <form style={box} onSubmit={submit}>
        <h2 id="terms-prompt-title" style={{ marginTop: 0 }}>Before you carry on</h2>
        <p>Run The Club has terms for clubs and a data processing agreement. Please read them and agree on behalf of the club.</p>
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', cursor: 'pointer', lineHeight: 1.4 }}>
          <input type="checkbox" checked={agree} onChange={(e) => { setAgree(e.target.checked); if (e.target.checked) setError(''); }} />
          <span>
            I agree to the{' '}
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">Terms for clubs</a>
            {' '}and the{' '}
            <a href={DPA_URL} target="_blank" rel="noopener noreferrer">Data processing agreement</a>
            {' '}on behalf of the club
          </span>
        </label>
        {error && <p role="alert" style={{ color: '#b00020', margin: '0.75rem 0 0' }}>{error}</p>}
        <button type="submit" disabled={busy} style={{ marginTop: '1rem', padding: '0.6rem 1.2rem', border: 0, borderRadius: 8, background: '#111', color: '#fff', cursor: 'pointer' }}>
          {busy ? 'Saving…' : 'Agree'}
        </button>
      </form>
    </div>
  );
}
